import script from "./CMastersRegistrationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMastersRegistrationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CMastersRegistrationPanel.vue?vue&type=style&index=0&id=247b5abc&lang=less"

const __exports__ = script;

export default __exports__